import React, { createContext, useState, useContext } from "react";

// Create a Context for the Lucky Draw
const AdminRoleContext = createContext();

// Create a provider component
export const AdminRoleProvider = ({ children }) => {
  const [selectedAdminRole, setSelectedAdminRole] = useState(null);
  const [actionOpen, setActionOpen] = useState(false);
  const [accessRightOpen, setAccessRightOpen] = useState(false);
  const [accessRights, setAccessRights] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  return (
    <AdminRoleContext.Provider
      value={{
        selectedAdminRole,
        setSelectedAdminRole,
        actionOpen,
        setActionOpen,
        accessRightOpen,
        setAccessRightOpen,
        accessRights,
        setAccessRights,
        isLoading,
        setIsLoading,
        isUpdating,
        setIsUpdating,
      }}
    >
      {children}
    </AdminRoleContext.Provider>
  );
};

// Custom hook to use the Lucky Draw context
export const useAdminRoleContext = () => useContext(AdminRoleContext);
